import { IKogIcon } from "@/main/@types/interfaceIcons";

interface IDoubleCheckIconProps extends IKogIcon {}
function DoubleCheckIcon({ color, width, height }: IDoubleCheckIconProps) {
	return (
		<svg
			fill={color}
			width={width ?? "20px"}
			height={height ?? "20px"}
			viewBox="0 0 20 22"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z" />
		</svg>
	);
}

export default DoubleCheckIcon;
